import React, { Component } from 'react'
import nissanLogoSource from '../styles/source/assets/img/maize-bag.PNG';
import tomatoebulbs from '../styles/source/assets/img/tomatoe-bulbs.PNG';
import fishfarm from '../styles/source/assets/img/fish-farm.PNG';
import poultryfarm from '../styles/source/assets/img/poultry-farm.PNG';
import potatoefarm from '../styles/source/assets/img/potatoe-farm.PNG';
import cowfarm from '../styles/source/assets/img/cow-farm.PNG';

class HomeComponent extends Component {
    constructor(props) {
        super(props)

    }

    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '140px' }}>
                <div style={{ width: '70%' }}>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <div style={{ flex: '30%', backgroundColor: 'lightgray', height: '270px' }}>
                                <img src = {tomatoebulbs} width = '100%' height='100%' alt='' title=''></img>
                            </div>
                            <div style={{ flex: '30%', backgroundColor: 'lightgray', height: '270px' }}>
                            <img src = {nissanLogoSource} width = '100%' height='100%' alt='' title=''></img>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ flex: '33%', backgroundColor: 'lightgray', height: '270px' }}>
                        <img src = {fishfarm} width = '100%' height='100%' alt='' title=''></img>
                        </div>
                        <div style={{ flex: '33%', backgroundColor: '#e5f2e5', height: '270px' }}>
                           <div style = {{ padding: '25px 14px 12px 14px', textAlign: 'center'}}>
                                <p style = {{fontSize: '55px', fontWeight: '500', }}>farmpick.ng</p>
                                <p style = {{fontSize: '25px', fontWeight: '400', }}>Online marketplace for wholesale farm produce</p>
                           </div>
                        </div>
                        <div style={{ flex: '33%', backgroundColor: 'lightgray', height: '270px' }}>
                        <img src = {poultryfarm} width = '100%' height='100%' alt='' title=''></img>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ width: '70%', display: 'flex' }}>
                            <div style={{ flex: '30%', backgroundColor: 'lightgray', height: '270px' }}>
                            <img src = {cowfarm} width = '100%' height='100%' alt='' title=''></img>
                            </div>
                            <div style={{ flex: '30%', backgroundColor: 'lightgray', height: '270px' }}>
                            <img src = {potatoefarm} width = '100%' height='100%' alt='' title=''></img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

HomeComponent.propTypes = {

}

export default HomeComponent